import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getValueFromStorage, setValueToStorage } from 'hooks/useLocalStorage';

import { type Roles, LocalStorageKeys } from 'constants/enums';
import type { JwtToken, User } from 'models/user.interface';

export interface UserState {
  user: User | null;
  jwtToken: JwtToken | null;
  role: Roles | null;
  clientId: string;
}

const initialState: UserState = {
  user: null,
  jwtToken: null,
  role: null,
  clientId: '',
};

export const userSlice = createSlice({
  name: 'loggedUser',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User|null>) => {
      state.user = action.payload;
      return state;
    },
    setUserRole: (state, action: PayloadAction<Roles|null>) => {
      state.role = action.payload;
      return state;
    },
    setClientId: (state, action: PayloadAction<string>) => {
      state.clientId = action.payload;
      return state;
    },
    setJwtToken: (state, action: PayloadAction<JwtToken|null>) => {
      state.jwtToken = action.payload;
      setValueToStorage(
        LocalStorageKeys.jwtToken,
        action.payload ? { ...action.payload, activeAt: new Date().getTime() } : null,
      );
      return state;
    },
    initializeStoreWithStoredData: (state) => {
      try {
        return {
          ...state,
          jwtToken: getValueFromStorage(LocalStorageKeys.jwtToken, null),
        };
      } catch {
        return state;
      }
    },
    resetUserState: () => {
      setValueToStorage(LocalStorageKeys.jwtToken, null);

      return initialState;
    },
  }
});

export const {
  setUser,
  setJwtToken,
  setUserRole,
  setClientId,
  initializeStoreWithStoredData,
  resetUserState,
} = userSlice.actions;

export default userSlice.reducer;
